import { all, takeLatest, fork, call, put } from "redux-saga/effects";
import actions from "./actions";
import { crawlExtractSellingPriceService } from "@iso/services";

export function* crawlExtractSellingPrice() {
  yield takeLatest(actions.CRAWL_EXTRACT_SELLING_PRICE_REQUEST, function* ({ payload }) {
    const {
      period,
      facilityCredentialId,
      resolve,
      reject
    } = payload;
    try {
      const response = yield call(crawlExtractSellingPriceService.crawlExtractSellingPrice, {
        period,
        facilityCredentialId,
        resolve,
        reject
      });
      yield put({
        type: actions.CRAWL_EXTRACT_SELLING_PRICE_SUCCESS,
        crawler: response,
      });
      yield resolve(response);
    } catch (e) {
      yield put({ type: actions.CRAWL_EXTRACT_SELLING_PRICE_ERROR });
      reject(e);
    }
  });
}

export function* getCrawlExtractSellingPrice() {
  yield takeLatest(actions.GET_CRAWL_EXTRACT_SELLING_PRICE_REQUEST, function* () {
    try {
      const report = yield call(crawlExtractSellingPriceService.getCrawlExtractSellingPrice);
      yield put({
        type: actions.GET_CRAWL_EXTRACT_SELLING_PRICE_SUCCESS,
        crawler: report,
      });
    } catch (error) {
      yield put({
        type: actions.GET_CRAWL_EXTRACT_SELLING_PRICE_ERROR,
        error: error.response,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(crawlExtractSellingPrice)]);
  yield all([fork(getCrawlExtractSellingPrice)]);
}
